import React from 'react';
import PropTypes from 'prop-types';

const StepItem = ({ number, label, isActive, isCompleted, isLast }) => {
  return (
    <div className="step-item">
      <div className="step-content">
        <div className={`step-circle ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}>
          {isCompleted ? (
            <svg className="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          ) : (
            <span className="step-number">{number}</span>
          )}
        </div>
        <div className="step-label">{label}</div>
      </div>
      {!isLast && <div className={`step-line ${isCompleted ? 'completed' : ''}`} />}
    </div>
  );
};

StepItem.propTypes = {
  number: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  isCompleted: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired
};

export default StepItem;
